// extracted by mini-css-extract-plugin
export var navLink = "header-module--navLink--16dz7";
export var pixelstrap = "header-module--pixelstrap--2YrAM";